import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login        from "@/pages/Login";
import Portal       from "@/pages/Portal";
import Admin        from "@/pages/Admin";
import PublicEvents from "@/pages/PublicEvents";
import EventDetail  from "@/pages/EventDetail";
import VerifyCert   from "@/pages/VerifyCert";
import CheckIn      from "@/pages/CheckIn";
import Gallery      from "@/pages/Gallery";
import MyEvents     from "@/pages/MyEvents";
import Feedback     from "@/pages/Feedback";
import MarketingLayout from "@/layout/MarketingLayout";
import Home         from "@/pages/marketing/Home";
import Features     from "@/pages/marketing/Features";
import HowItWorks   from "@/pages/marketing/HowItWorks";
import Products     from "@/pages/marketing/Products";
import Security     from "@/pages/marketing/Security";
import Contact      from "@/pages/marketing/Contact";

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* ── Public marketing site (Solution-style, BMSIT&M Events branded) ─ */}
            <Route element={<MarketingLayout />}>
              <Route path="/"              element={<Home />} />
              <Route path="/features"      element={<Features />} />
              <Route path="/how-it-works"  element={<HowItWorks />} />
              <Route path="/products"      element={<Products />} />
              <Route path="/security"      element={<Security />} />
              <Route path="/contact"       element={<Contact />} />
            </Route>

            {/* ── Public — no login ─────────────────────────────────────── */}
            <Route path="/login"             element={<Login />} />
            <Route path="/events"            element={<PublicEvents />} />
            <Route path="/events/:id"        element={<EventDetail />} />
            {/* Obfuscated public event/ticket URL used by confirmation emails:
                /6b345a51df60fed6f07c5ff42e1853d0?id=EVT-005&reg=…&token=…
                No :id path param here — EventDetail falls back to ?id= in the query. */}
            <Route path="/6b345a51df60fed6f07c5ff42e1853d0" element={<EventDetail />} />
            {/* verify.html */}
            <Route path="/verify"            element={<VerifyCert />} />
            {/* my-events.html */}
            <Route path="/my-events"         element={<MyEvents />} />
            {/* feedback.html */}
            <Route path="/feedback"          element={<Feedback />} />
            {/* gallery-upload.html — photographer portal (OTP-gated inside component) */}
            <Route path="/gallery-upload"    element={<Gallery />} />
            {/* checkin.html — OTP-gated inside component itself */}
            <Route path="/checkin"           element={<CheckIn />} />

            {/* ── Authenticated — any logged-in user ────────────────────── */}
            <Route path="/portal/*"          element={<ProtectedRoute><Portal /></ProtectedRoute>} />

            {/* ── Admin — incharge or superadmin ────────────────────────── */}
            <Route path="/admin"             element={<ProtectedRoute roles={["superadmin","incharge"]}><Admin /></ProtectedRoute>} />
            <Route path="/admin/*"           element={<ProtectedRoute roles={["superadmin","incharge"]}><Admin /></ProtectedRoute>} />
            <Route path="/8feb79055fe6f9e2641c4f17cb852393"
                   element={<ProtectedRoute roles={["superadmin","incharge"]}><Admin /></ProtectedRoute>} />

            {/* Fallback → public marketing home */}
            <Route path="*"                  element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </AuthProvider>
  );
}
